import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import IconSvg from "../IconSvg";

class Menu extends React.Component {
    static propTypes = {
        activePage: PropTypes.string.isRequired,
        onPageChange: PropTypes.func.isRequired,
        showAdvertError: PropTypes.bool,
        showPricelistError: PropTypes.bool,
    };

    render() {
        const {activePage, onPageChange, showAdvertError, showPricelistError} = this.props;

        return (
            <div className="btn-group w-100 justify-content-center" role="group">
                <Button color="primary" onClick={() => onPageChange('advert')} outline
                        className={(activePage === 'advert' ? 'active ' : '') + (showAdvertError ? 'has-warning' : '')} >
                    {showAdvertError &&
                    <IconSvg id='warning'/>
                    }
                    <FormattedMessage id="advert_modal.nav.advert.title" defaultMessage="Advert" />
                </Button>
                <Button color="primary" onClick={() => onPageChange('pricelist')} outline
                        className={(activePage === 'pricelist' ? 'active ' : '') + (showPricelistError ? 'has-warning' : '')} >
                    {showPricelistError &&
                    <IconSvg id='warning'/>
                    }
                    <FormattedMessage id="advert_modal.nav.pricelist.title" defaultMessage="Pricelist" />
                </Button>
            </div>
        )
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/AdvertForm/Menu.jsx